import { stats } from "@/mocks/categories";

export default function StatsSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="lg:w-1/2">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              Why Use Our<br />
              Spreadsheet Hub?
            </h2>
            <p className="mt-4 text-sm text-foreground-500 leading-relaxed max-w-md">
              Instead of searching blindly through thousands of listings, our pandabuyspreadsheet system organizes everything into clean, filterable categories so you find exactly what you want faster.
            </p>

            <div className="mt-10 grid grid-cols-3 gap-0 divide-x divide-background-200">
              {stats.map((stat, idx) => (
                <div key={idx} className={`${idx === 0 ? "pl-0" : "pl-5"}`}>
                  <div className="text-3xl md:text-4xl font-heading font-bold text-accent-500">
                    {stat.value}
                  </div>
                  <p className="mt-1 text-xs text-foreground-500 leading-snug">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-1/2 relative">
            <div className="relative h-[400px] rounded-3xl overflow-hidden bg-gradient-to-br from-accent-50 to-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Beautifully%20organized%20fashion%20editorial%20flat%20lay%20with%20multiple%20curated%20clothing%20pieces%20in%20cream%20beige%20and%20warm%20taupe%20tones%20arranged%20in%20grid%20pattern%20on%20soft%20textured%20surface%20natural%20daylight%20from%20window%20clean%20modern%20aesthetic%20harmonious%20layout%20professional%20product%20photography%20subtle%20textures%20visible%20high%20end%20commercial%20style%20warm%20inviting%20palette%20fresh%20sophisticated%20composition%20organized%20systematic%20feel&width=800&height=600&seq=stats-visual-v5&orientation=landscape"
                alt="Curated product collection"
                className="absolute inset-0 w-full h-full object-cover opacity-80"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-white/70 via-transparent to-transparent"></div>
            </div>

            <div className="absolute -bottom-3 left-6 right-6 bg-white rounded-2xl border border-background-200 p-4 flex items-center gap-4">
              <div className="w-14 h-14 rounded-full bg-accent-50 flex items-center justify-center flex-shrink-0">
                <i className="ri-check-double-line text-accent-500 text-2xl"></i>
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-950">Updated Daily</p>
                <p className="text-xs text-foreground-500">New spreadsheet finds added every day</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}